module.exports = __webpack_public_path__ + "img/en.9e3e57a7.png";